import { useContext } from 'react';

import { IStudentDataContext, StudentDataContext } from '../contexts/StudentDataContext/StudentDataContext';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useStudentRefetch = (): IStudentDataContext => useContext(StudentDataContext);

export default useStudentRefetch;
